import { render, staticRenderFns } from "./Death.vue?vue&type=template&id=7c0fb0a5&"
import script from "./Death.vue?vue&type=script&lang=js&"
export * from "./Death.vue?vue&type=script&lang=js&"
import style0 from "./Death.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDialog,VForm,VProgressCircular})
